import { useEffect, useState } from "react";

/** Enkel cache så att samma film bara behöver läsas av en gång per session. */
const memory = new Map<string, string>();
const KEY_PREFIX = "sellavo_poster:";

function readCache(src: string): string | null {
  const hit = memory.get(src);
  if (hit) return hit;
  try {
    const stored = sessionStorage.getItem(KEY_PREFIX + src);
    if (stored) {
      memory.set(src, stored);
      return stored;
    }
  } catch {
    /* privat läge – strunt samma */
  }
  return null;
}

function writeCache(src: string, dataUrl: string) {
  memory.set(src, dataUrl);
  try {
    sessionStorage.setItem(KEY_PREFIX + src, dataUrl);
  } catch {
    /* full lagring – strunt samma */
  }
}

/**
 * Plockar ut första bildrutan ur en film så att den kan visas som stillbild
 * istället för en tom, mörk ruta med en play-knapp.
 */
export function useVideoPoster(src: string | null | undefined): string | null {
  const [poster, setPoster] = useState<string | null>(() => (src ? readCache(src) : null));

  useEffect(() => {
    if (!src) {
      setPoster(null);
      return;
    }
    const cached = readCache(src);
    if (cached) {
      setPoster(cached);
      return;
    }
    let alive = true;
    void (async () => {
      const { extractVideoPoster } = await import("@/lib/video-poster");
      const frame = await extractVideoPoster(src);
      if (!alive || !frame) return;
      writeCache(src, frame);
      setPoster(frame);
    })();
    return () => {
      alive = false;
    };
  }, [src]);

  return poster;
}
